import getClassList from './get-class-list.js';

/**
 * Get a space-separated list of classes based on the classMap
 *
 * @example
 * const classMap = {
 *   default: "brk-hello-world-root",
 *   modifierPrefix: "brk-hello-world",
 *   modifiers: [
 *     {
 *       condition: aTruthyValue,
 *       className: "full-width",
 *     },
 *     {
 *       condition: aFalsyValue,
 *       className: "on-dark",
 *     },
 *   ],
 * };
 *
 * getClassName(classMap); // returns "brk-hello-world-root brk-hello-world--full-width"
 */
function getClassName(classMap) {
    return getClassList(classMap).join(" ");
}

export { getClassName as default };
//# sourceMappingURL=get-class-name.js.map
